// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-m_hh","advertDetailContacts__header":"c-m_hi"};